import React from "react";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import Objecthistory from "./Objecthistroy";
import { createPortal } from "react-dom";

const Objecthistorydrawer = ({
  fromList = false,
  photography = false,
  id,
  isOpenhistory,
  toggleDrawerhistory,
  setIsOpenhistory,
}) => {
  return (
    <>
      {fromList ? (
       
        createPortal(
          <Drawer
            open={isOpenhistory}
            size={500}
            onClose={toggleDrawerhistory}
            direction="right"
            className="bla bla bla"
            style={{
              zIndex:  9999,
              position: "fixed", // ensure it overlays, not shifts layout
              top: 0,
              right: 0,
              overflowX: "hidden",
              overscrollBehavior:"contain"
            }}
            enableOverlay={false}
          >
            <div>
              <Objecthistory id={id} setIsOpenhistory={setIsOpenhistory} />
            </div>
          </Drawer>,
          document.body
        )
      ) : (
        <Drawer
          open={isOpenhistory}
          size={500}
          onClose={toggleDrawerhistory}
          direction="right"
          className="bla bla bla"
          style={{
            zIndex: photography ? 9999 : 101,
            position: "fixed", // ensure it overlays, not shifts layout
            top: 0,
            right: 0,
            overflowX: "hidden",
          }}
          enableOverlay={false}
        >
          <div>
            <Objecthistory id={id} setIsOpenhistory={setIsOpenhistory} />
          </div>
        </Drawer>
      )}
    </>
  );
};

export default Objecthistorydrawer;
